/**
 * The Game Master (GM) - Special entity for system messages in game chat
 *
 * Used by the orchestrator to output:
 * - Welcome messages
 * - Scene transitions
 * - Round summaries
 * - System announcements
 * - GM answers to player questions (via "GM:" prefix)
 *
 * The GM is the unified voice of the game - both for system messages
 * and for answering player questions about rules, lore, and game state.
 */

import { getGameImageUrl, getStaffAvatarUrl } from './media-urls.js';

export const GAME_MASTER = {
  /** Character ID for The Game Master */
  charId: 'game_master',

  /** Display name */
  name: 'Polymyth',

  /** Avatar URL - Polymyth ankh brand avatar */
  avatarUrl: '/gm-avatar.svg',

  /** Portrait URL for larger displays (served from GCS) */
  portraitUrl: getGameImageUrl('gm-portrait.webp'),

  /** Fallback emoji if images not available */
  avatarEmoji: '☥',

  /** Chat bubble color - mystical violet */
  chatColor: '#8b5cf6', // violet-500
} as const;

/** @deprecated Use GAME_MASTER instead */
export const NARRATOR = GAME_MASTER;

export type GameMasterInfo = typeof GAME_MASTER;
/** @deprecated Use GameMasterInfo instead */
export type NarratorInfo = GameMasterInfo;

/**
 * Master Kira — training master at the hilltop. Used in-game post-duel to
 * deliver performance coaching as a distinct sender (separate from the GM).
 */
export const MASTER_KIRA = {
  charId: 'kira',
  name: 'Master Kira',
  avatarUrl: getStaffAvatarUrl('kira-avatar.webp'),
  avatarEmoji: '⚔️',
  chatColor: '#f59e0b',
} as const;

export type MasterKiraInfo = typeof MASTER_KIRA;
